import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Breadcrumb } from './breadcrumb.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumbItems: Breadcrumb[] = [];
  showDropdown = false;
  isMobile = false;

  ngOnInit() {
    this.checkScreenSize();
  }

  get first() {
    return this.breadcrumbItems[0];
  }

  get last() {
    return this.breadcrumbItems[this.breadcrumbItems.length - 1];
  }

  get middle() {
    return this.breadcrumbItems.slice(1, this.breadcrumbItems.length - 1);
  }

  hasMiddle() {
    return this.middle.length > 0;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  @HostListener('window:resize')
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.menu-mobil')) {
      this.showDropdown = false;
    }
  }

  selectItem() {
    this.showDropdown = false;
  }

}
